import {Col, Container, Row} from "@deere/ux.uxframe-react";
import React from "react";
import {Card} from "react-bootstrap";

function RegistrationSuccess() {
    return (
        <div>
                <Container fluid>
                    <Row>
                        <Col>
                            <div className="uxf-error-example d-flex flex-wrap text-center mb-3" style={{paddingTop:'15px'}}>
                                <Card
                                    className="card w-100 align-items-center"
                                    style={{ maxWidth: "525px" }}
                                >
                                    <Card.Body className="card-body w-100">

                                            <svg focusable="false" aria-hidden="true" className="uxf-alert-icon" fill="#367c2b"
                                                 width="100" height="100" viewBox="0 0 24 24"  text-align="center">
                                                <path d="M0 0h24v24H0z" fill="none"></path>
                                                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                                            </svg>

                                        <p className="success-msg mb-5" >
                                            Thank you for registering your equipment.  We look forward to connecting with you!
                                        </p>

                                    </Card.Body>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>
        </div>
    );
}

export default RegistrationSuccess;
